import { Component, Input } from '@angular/core';
import { LookUpResourceModel } from 'src/app/section-wise/models/lookup-resource.model';

@Component({
  selector: 'insured-people-detail-sw, [insuredPeopleDetailSw]',
  templateUrl: './insured-people-detail-sw.component.html'
})
export class InsuredPeopleDetailSwComponent {
  isActive = false;
  @Input() insuredPeopleDetail: Array<LookUpResourceModel>;

  constructor() {}

  toggleActive(): void {
    this.isActive = !this.isActive;
  }
}
